import api from 'api';
import { parseAddressOption } from 'utils/parsers';

import { defaultPagination } from './general';

type GetPartnersType = {id: number | string}

export const listPartners = async (params) => api().get('/partners', { params: { ...defaultPagination, ...params } });

export const getPartners = async ({ id }:GetPartnersType) => api().get(`/partners/${id}`);

export const importPartners = async ({ data }) => api().post('import/partners', data, {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});

export const createPartners = async ({ data }) => {
  const body = {
    ...data,
    workingHours: data.workingHours.filter((hour) => !!hour),
    address: parseAddressOption(data.address),
  };
  return api().post('/partners', body);
};

export const updatePartners = async ({ id, data }) => {
  const body = {
    ...data,
    workingHours: data.workingHours.filter((hour) => !!hour),
    address: parseAddressOption(data.address),
  };
  return api().put(`/partners/${id}`, body);
};
